import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

export const useClassroomRosterSyncGetList = (options) => {
  return useRestQuery(`${API_BASE_URL}/api/v2/roster-sync/`, options);
};

export default useClassroomRosterSyncGetList;
